import { apiSlice } from './apiSlice';


export type CompaniesCountRegion = {
    region: string;
    companies: number;
}

export type CompaniesCountIndustry = {
    industry: string;
    isSub: boolean;
    companies: number;
}

export type CompaniesCountCapability = {
    name: string;
    count: number;
}


export const visualisationSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompaniesCountByRegion: builder.query<CompaniesCountRegion[], void>({
            query: () => '/visualisation/companies?filters=countByRegion',
            keepUnusedDataFor: 60,
        }),
        getCompaniesCountByIndustry: builder.query<CompaniesCountIndustry[], void>({
            query: () => '/visualisation/companies?filters=countByIndustry',
            keepUnusedDataFor: 60,
        }),
        getCompaniesCountBySubIndustry: builder.query<CompaniesCountIndustry[], void>({
            query: () => '/visualisation/companies?filters=countBySubIndustry',
            keepUnusedDataFor: 60,
        }),
        getCompaniesCountByCapability: builder.query<CompaniesCountCapability[], void>({
            query: () => '/visualisation/companies?filters=countByCapability',
            keepUnusedDataFor: 60,
        }),
    })
})

export const { useGetCompaniesCountByRegionQuery, useGetCompaniesCountByIndustryQuery, useGetCompaniesCountBySubIndustryQuery, useGetCompaniesCountByCapabilityQuery } = visualisationSlice